import {
  AppRoute,
  UserAuthorizationList,
  UserDataType,
  UserRoleList,
} from "utils/Router/router.types";
import React, { lazy } from "react";

import { PAGE_URLS } from "./utils/constants";
import { Rule } from "./utils/Router/router.rule";
import { CustomFallbacks } from "utils/Router/CustomFallbacks";

const Playbook = lazy(
  () => import(/* webpackChunkName: "Playbook" */ "./views/Playbook")
);

const PlaybookContent = lazy(
  () =>
    import(/* webpackChunkName: "PlaybookContent" */ "./views/PlaybookContent")
);

const PlaybookMonetize = lazy(
  () =>
    import(
      /* webpackChunkName: "PlaybookMonetize" */ "./views/PlaybookMonetize"
    )
);

const ReferralInput = lazy(
  () => import(/* webpackChunkName: "ReferralInput" */ "./views/ReferralInput")
);

const WishlinkCreatorOauth = lazy(
  () =>
    import(
      /* webpackChunkName: "WishlinkCreatorOauth" */ "./views/WishlinkCreatorOauth"
    )
);

const PayoutExplainerVideo = lazy(
  () =>
    import(
      /* webpackChunkName: "PayoutExplainerVideo" */ "./views/PayoutExplainerVideo/index.jsx"
    )
);

const EnableEngageSTK = lazy(
  () =>
    import(
      /* webpackChunkName: "EnableEngageSTK" */ "./views/EnableEngageSTK/index.jsx"
    )
);

const EngageComment = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageComment" */ "./views/EngageComment/index.jsx"
    )
);

const EngageCommentV2 = lazy(
  () =>
    import(/* webpackChunkName: "EngageCommentV2" */ "./views/EngageCommentV2")
);

const EngageShare = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageShare" */ "./views/EngageShare/index.jsx"
    )
);

const EngageShareV2 = lazy(
  () => import(/* webpackChunkName: "EngageShareV2" */ "./views/EngageShareV2")
);

const EngageFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageFTUXV2" */ "./views/EngageFTUXV2/index.jsx"
    )
);

const EngageRealisationFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageRealisationFTUX" */ "./views/EngageRealisationFTUX/index.jsx"
    )
);

const CollabFTUX = lazy(
  () =>
    import(/* webpackChunkName: "CollabFTUX" */ "./views/CollabFTUX/index.jsx")
);

const CollabChatFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "CollabChatFTUX" */ "./views/CollabChatFTUX/index.jsx"
    )
);

const CollabRealisationFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "CollabRealisationFTUX" */ "./views/CollabFTUX/CollabFTUXRealisationPage.jsx"
    )
);

const RewardsFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "RewardsFTUX" */ "./views/RewardsFTUX/index.jsx"
    )
);

const RewardsRealisationFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "RewardsRealisationFTUX" */ "./views/RewardsFTUX/RewardsFTUXRealisationPage.jsx"
    )
);

const GrowthFTUX = lazy(
  () =>
    import(/* webpackChunkName: "GrowthFTUX" */ "./views/GrowthFTUX/index.jsx")
);

const GrowthRealisationFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "GrowthRealisationFTUX" */ "./views/GrowthFTUX/GrowthFTUXRealisationPage.jsx"
    )
);

const FacebookFTUX = lazy(
  () => import(/* webpackChunkName: "FacebookFTUX" */ "./views/FacebookFTUX")
);

const FacebookFTUXV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "FacebookFTUXV2" */ "./views/FacebookFTUXV2/index.jsx"
    )
);

const SelectByWishlinkFTUXV3 = lazy(
  () =>
    import(
      /* webpackChunkName: "SelectByWishlinkFTUXV3" */ "./views/SelectByWishlinkFTUXV3"
    )
);

const SelectByWishlinkRewardsFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "SelectByWishlinkRewardsFTUX" */ "./views/SelectByWishlinkRewardsFTUX"
    )
);

const SelectByWishlinkWrapFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "SelectByWishlinkWrapFTUX" */ "./views/SelectByWishlinkWrapFTUX"
    )
);

const StreaksFTUX = lazy(
  () => import(/* webpackChunkName: "StreaksFTUX" */ "./views/StreaksFTUX")
);

const MonthlyOrderStatus = lazy(
  () =>
    import(
      /* webpackChunkName: "MonthlyOrderStatus" */ "./views/MonthlyOrderStatus/index.jsx"
    )
);

const EngageDebugger = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageDebugger" */ "./views/EngageDebugger/index.jsx"
    )
);

const EngageDiagnosisReport = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageDiagnosisReport" */ "./views/EngageDiagnosisReport/index.jsx"
    )
);

const Kyc = lazy(
  () => import(/* webpackChunkName: "Kyc" */ "./views/Kyc/index.jsx")
);

const FestiveRecordPage = lazy(
  () =>
    import(
      /* webpackChunkName: "FestiveRecordPage" */ "views/FestiveRecordPage"
    )
);

const WishlinkWrapped25 = lazy(
  () =>
    import(
      /* webpackChunkName: "WishlinkWrapped25" */ "views/WishlinkWrapped25/WishlinkWrapped25"
    )
);

const PastPayouts = lazy(
  () => import(/* webpackChunkName: "PastPayouts" */ "./views/PastPayouts")
);

const PastPayoutDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "PastPayoutDetails" */ "./views/PastPayoutDetails"
    )
);

// Sourcing Maintenance
const SourcingMaintenance = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingMaintenance" */ "./views/SourcingMaintenance"
    )
);

const SourcingCollection = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingCollection" */ "./sourcing/views/Collections"
    )
);

const BrandSourcingCollection = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingCollectionWrapper" */ "./sourcing/views/Collections/BrandSourcingCollectionWrapper"
    )
);

const SourcingCart = lazy(
  () => import(/* webpackChunkName: "SourcingCart" */ "./sourcing/views/Cart")
);

const ManualSourcing = lazy(
  () =>
    import(
      /* webpackChunkName: "ManualSourcing" */ "./sourcing/views/ManualSourcing"
    )
);

const BrandSourcingCartWrapper = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingCartWrapper" */ "./sourcing/views/Cart/BrandSourcingCartWrapper"
    )
);

const SourcingWishlist = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingWishlist" */ "./sourcing/views/Wishlist"
    )
);

const BrandSourcingUnifiedWishlist = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingWishlistAll" */ "./sourcing/views/Wishlist/BrandSourcingAllWishlistWrapper"
    )
);

const BrandSourcingWishlist = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingWishlist" */ "./sourcing/views/Wishlist/BrandSourcingWishlistWrapper"
    )
);

const BrandAndSourcingUnifiedMyOrders = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandAndSourcingUnifiedMyOrders" */ "./sourcing/views/MyOrders"
    )
);

const SourcingProduct = lazy(
  () =>
    import(/* webpackChunkName: "SourcingProduct" */ "./sourcing/views/Product")
);

const BrandSourcingProduct = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingProduct" */ "./sourcing/views/Product/BrandSourcingProductWrapper"
    )
);

// CAT-407 — /setup-journey is no longer a page. It is a thin entry point that
// opens the journey overlay over Home; the journey itself is loaded by
// components/SetupJourneyOverlay.
const SetupJourneyRouteEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "SetupJourneyRouteEntry" */ "./components/SetupJourneyOverlay/SetupJourneyRouteEntry"
    )
);

const IntentCapture = lazy(
  () => import(/* webpackChunkName: "IntentCapture" */ "./views/IntentCapture")
);

const EngageSetupJourney = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageSetupJourney" */ "./views/EngageSetupJourney"
    )
);

const BrandCampaignUhOh = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandCampaignUhOh" */ "./views/BrandCampaignUhOh"
    )
);

const CreatorShop = lazy(
  () => import(/* webpackChunkName: "Shop" */ "./views/CreatorShop")
);

const CreatorContent = lazy(
  () =>
    import(/* webpackChunkName: "CreatorContent" */ "./views/CreatorContent")
);

const PostFrameDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "PostFrameDetails" */ "./views/PostFrameDetails"
    )
);

const NewPost = lazy(
  () => import(/* webpackChunkName: "NewPost" */ "./views/NewPost")
);

const AddProducts = lazy(
  () => import(/* webpackChunkName: "AddProducts" */ "./views/AddProducts")
);

const AddProductsAutoScrape = lazy(
  () =>
    import(
      /* webpackChunkName: "AddProductsAutoScrape" */ "./views/AddProductsAutoScrape"
    )
);

const PreviewLinks = lazy(
  () => import(/* webpackChunkName: "PreviewLinks" */ "./views/PreviewLinks")
);

const NewCollection = lazy(
  () => import(/* webpackChunkName: "NewCollection" */ "./views/NewCollection")
);

const AddProductsCollection = lazy(
  () =>
    import(
      /* webpackChunkName: "AddProductsCollection" */ "./views/AddProductsCollection"
    )
);

const PreviewPost = lazy(
  () => import(/* webpackChunkName: "PreviewPost" */ "./views/PreviewPost")
);

const FirebaseLogin = lazy(
  () => import(/* webpackChunkName: "FirebaseLogin" */ "./views/FirebaseLogin")
);

const SocialMediaLogin = lazy(
  () =>
    import(
      /* webpackChunkName: "SocialMediaLogin" */ "./views/SocialMediaLogin"
    )
);

const InstaLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "InstaLoginSuccess" */ "./views/InstaLoginSuccess"
    )
);

const FacebookLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "FacebookLoginSuccess" */ "./views/FacebookLoginSuccess"
    )
);

const PinterestLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "PinterestLoginSuccess" */ "./views/PinterestLoginSuccess"
    )
);

const SnapchatLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "SnapchatLoginSuccess" */ "./views/SnapchatLoginSuccess"
    )
);

const YoutubeLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "YoutubeLoginSuccess" */ "./views/YoutubeLoginSuccess"
    )
);

const FacebookPageSelection = lazy(
  () =>
    import(
      /* webpackChunkName: "FacebookPageSelection" */ "./views/FacebookPageSelection"
    )
);

const Brands = lazy(
  () => import(/* webpackChunkName: "Brands" */ "./views/Brands")
);

const BrandsV2 = lazy(
  () => import(/* webpackChunkName: "BrandsV2" */ "./views/BrandsV2")
);

const BrandsHubOpportunities = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsHubOpportunities" */ "./views/BrandsHubOpportunities"
    )
);

const BrandsHubExcitingSales = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsHubExcitingSales" */ "./views/BrandsHubExcitingSales"
    )
);

const BrandsHubFreshBrands = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsHubFreshBrands" */ "./views/BrandsHubFreshBrands"
    )
);

const BrandsHubContentInspiration = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsHubContentInspiration" */ "./views/BrandsHubContentInspiration"
    )
);

const BrandsHubContentInspirationReelEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsHubContentInspirationReelEntry" */ "./views/BrandsHubContentInspiration/ReelEntry"
    )
);

const DiscoverSearchResults = lazy(
  () =>
    import(
      /* webpackChunkName: "DiscoverSearchResults" */ "./views/DiscoverSearchResults"
    )
);

const Clothing = lazy(
  () => import(/* webpackChunkName: "Clothing" */ "./views/Clothing")
);

const AffiliateProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "AffiliateProducts" */ "./views/AffiliateProducts"
    )
);

const Profile = lazy(
  () => import(/* webpackChunkName: "Profile" */ "./views/Profile")
);

const CrossPosting = lazy(
  () => import(/* webpackChunkName: "CrossPosting" */ "./views/CrossPosting")
);

const SnapchatCrossPosting = lazy(
  () =>
    import(
      /* webpackChunkName: "SnapchatCrossPosting" */ "./views/SnapchatCrossPosting"
    )
);

const CrossPostingV2 = lazy(
  () =>
    import(
      /* webpackChunkName: "CrossPostingV2" */ "./views/CrossPosting/CrossPostingV2.jsx"
    )
);

const ThriftAdmin = lazy(
  () =>
    import(
      /* webpackChunkName: "ThriftAdmin" */ "./views/ThriftAdmin/index.jsx"
    )
);

const CrossPostingFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "CrossPostingFTUX" */ "./views/CrossPosting/CrossPostingFTUX"
    )
);

const CrossPostingEducation = lazy(
  () =>
    import(
      /* webpackChunkName: "CrossPostingEducation" */ "./views/CrossPosting/CrossPostingEducation"
    )
);

const BankDetails = lazy(
  () => import(/* webpackChunkName: "BankDetails" */ "./views/BankDetails")
);
const BankDetailsVerification = lazy(
  () =>
    import(
      /* webpackChunkName: "BankDetails" */ "./views/BankDetailsVerification"
    )
);
const RazorpayVerificationFlow = lazy(
  () =>
    import(
      /* webpackChunkName: "RazorpayVerificationFlow" */ "./views/RazorpayVerification"
    )
);
const PostAnalytics = lazy(
  () => import(/* webpackChunkName: "PostAnalytics" */ "./views/PostAnalytics")
);

const CollectionAnalytics = lazy(
  () =>
    import(
      /* webpackChunkName: "CollectionAnalytics" */ "./views/CollectionAnalytics"
    )
);

const Home = lazy(
  () => import(/* webpackChunkName: "Home" */ "./views/CreatorHome")
);

const Engage = lazy(
  () => import(/* webpackChunkName: "Engage" */ "./views/Engage")
);

const EngageInstagram = lazy(
  () =>
    import(/* webpackChunkName: "EngageInstagram" */ "./views/EngageInstagram")
);

const EngageCommentsInbox = lazy(
  () =>
    import(
      /* webpackChunkName: "EngageCommentsInbox" */ "./views/EngageCommentsInbox"
    )
);

const EngageFacebook = lazy(
  () =>
    import(/* webpackChunkName: "EngageFacebook" */ "./views/EngageFacebook")
);

const CreatorAdmin = lazy(
  () => import(/* webpackChunkName: "CreatorAdmin" */ "./views/CreatorAdmin")
);

const CrmEmbed = lazy(
  () => import(/* webpackChunkName: "CrmEmbed" */ "./views/CrmEmbed")
);

const Why = lazy(() => import(/* webpackChunkName: "Why" */ "./views/Why"));

const AuthStatus = lazy(
  () => import(/* webpackChunkName: "AuthStatus" */ "./views/AuthStatus")
);

const Faq = lazy(
  () => import(/* webpackChunkName: "Faq" */ "./views/Faq/index.jsx")
);

const FaqItem = lazy(
  () => import(/* webpackChunkName: "FaqItem" */ "./views/Faq/FaqItem.jsx")
);

const FaqQuestion = lazy(
  () =>
    import(/* webpackChunkName: "FaqQuestion" */ "./views/Faq/FaqQuestion.jsx")
);

const SocialLoginSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "SocialLoginSuccess" */ "./views/SocialLoginSuccess"
    )
);

const LoginSuccess = lazy(
  () => import(/* webpackChunkName: "LoginSuccess" */ "./views/LoginSuccess")
);

const ErrorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ErrorPage" */ "./components/Fallback/ErrorPage"
    )
);

const ProductAnalytics = lazy(
  () =>
    import(
      /* webpackChunkName: "ProductAnalytics" */ "./views/ProductAnalytics"
    )
);

const WishlinkRewards = lazy(
  () =>
    import(/* webpackChunkName: "WishlinkRewards" */ "./views/WishlinkRewards")
);

const WishlinkStreaks = lazy(
  () =>
    import(/* webpackChunkName: "WishlinkStreaks" */ "./views/WishlinkStreaks")
);

const StreakTrackProgress = lazy(
  () =>
    import(
      /* webpackChunkName: "StreakTrackProgress" */ "./views/Streaks/components/StreaksTrackProgress"
    )
);

const StreaksHowItWorks = lazy(
  () =>
    import(
      /* webpackChunkName: "StreaksHowItWorks" */ "./views/Streaks/components/HowItWorks"
    )
);

const StreakLearnMoreRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "StreakLearnMoreRedirect" */ "./views/Streaks/components/StreakLearnMoreRedirect"
    )
);

const RewardHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "RewardHistory" */ "./views/RewardDetails/Rewards/RewardHistory"
    )
);

const RewardFullLeaderboard = lazy(
  () =>
    import(
      /* webpackChunkName: "RewardLeaderboard" */ "./views/RewardDetails/Rewards/RewardFullLeaderboard"
    )
);

const OrderHistory = lazy(
  () => import(/* webpackChunkName: "OrderHistory" */ "./views/OrderHistory")
);

const Address = lazy(
  () => import(/* webpackChunkName: "Address" */ "./views/Address")
);

const AppLoginTrigger = lazy(
  () =>
    import(/* webpackChunkName: "AppLoginTrigger" */ "./views/AppLoginTriggers")
);

const Notification = lazy(
  () => import(/* webpackChunkName: "Notification" */ "./views/Notification")
);

const Tnc = lazy(() => import(/* webpackChunkName: "Tnc" */ "./views/Tnc"));

const Referral = lazy(
  () => import(/* webpackChunkName: "Referral" */ "./views/Referral")
);

const RecommendedCollections = lazy(
  () =>
    import(
      /* webpackChunkName: "RecommendedCollections" */ "./views/RecommendedCollections"
    )
);

const FirstLinkSelectBrands = lazy(
  () =>
    import(
      /* webpackChunkName: "FirstLinkSelectBrands" */ "./views/FirstLinkSelectBrands"
    )
);

const Welcome = lazy(
  () => import(/* webpackChunkName: "Welcome" */ "./views/Welcome")
);

const Otp = lazy(() => import(/* webpackChunkName: "Otp" */ "./views/Otp"));

const FavouriteBrands = lazy(
  () =>
    import(/* webpackChunkName: "FavouriteBrands" */ "./views/FavouriteBrands")
);

const SourcingHome = lazy(
  () => import(/* webpackChunkName: "SourcingHome" */ "./sourcing/views/Home")
);

const SourcingMini = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingMini" */ "./sourcing/views/SourcingMini/index.jsx"
    )
);

const AnalyticsV2 = lazy(
  () => import(/* webpackChunkName: "AnalyticsV2" */ "./views/AnalyticsV2")
);

const WishlinkShoppingPage = lazy(
  () =>
    import(
      /* webpackChunkName: "WishlinkShoppingPage" */ "./views/WishlinkShoppingPage"
    )
);

const PendingCommission = lazy(
  () =>
    import(
      /* webpackChunkName: "PendingCommission" */ "./views/PayoutPendingCommission"
    )
);

const ConfirmedCommission = lazy(
  () =>
    import(
      /* webpackChunkName: "ConfirmedCommission" */ "./views/PayoutConfirmedCommission"
    )
);

const PayoutStatusPage = lazy(
  () =>
    import(
      /* webpackChunkName: "PayoutStatusPage" */ "./views/AnalyticsV2/Components/PayoutsCX/PayoutStatusPage"
    )
);

const PayoutOrderLedger = lazy(
  () =>
    import(
      /* webpackChunkName: "PayoutOrderLedger" */ "./views/PayoutOrderLedger"
    )
);

const Levied = lazy(
  () => import(/* webpackChunkName: "Levied" */ "./views/Levied")
);

const AnalyticsTNC = lazy(
  () => import(/* webpackChunkName: "AnalyticsTNC" */ "./views/AnalyticsTNC")
);

const PostDetails = lazy(
  () => import(/* webpackChunkName: "PostDetails" */ "./views/PostDetails")
);

const SourcingAccess = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingAccess" */ "./sourcing/views/SourcingAccess"
    )
);

const SourcingLocked = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingLocked" */ "./sourcing/views/SourcingLocked"
    )
);

const SourcingCredits = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingCredits" */ "./sourcing/views/SourcingCredits"
    )
);

const MiniSourcingActiveOrders = lazy(
  () =>
    import(
      /* webpackChunkName: "MiniSourcingActiveOrders" */ "./sourcing/views/MiniSourcingActiveOrders"
    )
);

const MiniSourcingCart = lazy(
  () =>
    import(
      /* webpackChunkName: "MiniSourcingCart" */ "./sourcing/views/MiniSourcingCart"
    )
);
const SourcingCreditHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingCreditHistoryWrapper" */ "./views/SourcingAndBrandCreditHistory/SourcingCreditHistoryWrapper"
    )
);
const SourcingOrderConfirmation = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingOrderConfirmationWrapper" */ "./views/SourcingAndBrandOrderConfirmation/SourcingOrderConfirmationWrapper"
    )
);
const SourcingMyOrders = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingMyOrdersWrapper" */ "./sourcing/views/MyOrders/SourcingMyOrdersWrapper"
    )
);

// Brand Sourcing Starts
const BrandSourcingHome = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingHome" */ "./views/BrandSourcingHome"
    )
);
const BrandSourcingFTUX = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingFTUX" */ "./views/BrandSourcingFTUX"
    )
);
const BrandSourcingCreditHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingCreditHistoryWrapper" */ "./views/SourcingAndBrandCreditHistory/BrandSourcingCreditHistoryWrapper"
    )
);
const BrandSourcingOrderConfirmation = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingOrderConfirmationWrapper" */ "./views/SourcingAndBrandOrderConfirmation/BrandSourcingOrderConfirmationWrapper"
    )
);
const BrandSourcingMyOrders = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandSourcingMyOrdersWrapper" */ "./sourcing/views/MyOrders/BrandSourcingMyOrdersWrapper"
    )
);
// Brand Sourcing Ends

const SourcingProductReviews = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingProductReviews" */ "./sourcing/views/ProductReview"
    )
);

const SourcingProductReviewForm = lazy(
  () =>
    import(
      /* webpackChunkName: "SourcingProductReviewForm" */ "./sourcing/views/ProductReview/ProductReviewForm"
    )
);

const UserBlocked = lazy(
  () => import(/* webpackChunkName: "UserBlocked" */ "./views/UserBlocked")
);

const RewardDetails = lazy(
  () => import(/* webpackChunkName: "RewardDetails" */ "./views/RewardDetails")
);

const RewardPostListDrilldown = lazy(
  () =>
    import(
      /* webpackChunkName: "RewardPostListDrilldown" */ "./views/RewardDetails/PostListDrilldown"
    )
);

const DiscoverContent = lazy(
  () =>
    import(/* webpackChunkName: "DiscoverContent" */ "./views/DiscoverContent")
);

const CopyLinks = lazy(
  () => import(/* webpackChunkName: "CopyLinks" */ "./views/CopyLinks")
);

const CreateDiy = lazy(
  () => import(/* webpackChunkName: "CreateDiy" */ "./views/CreateDiy")
);

const ChooseReplyType = lazy(
  () =>
    import(/* webpackChunkName: "ChooseReplyType" */ "./views/ChooseReplyType")
);

const AddCustomLinks = lazy(
  () =>
    import(/* webpackChunkName: "AddCustomLinks" */ "./views/AddCustomLinks")
);

const AddTextMessage = lazy(
  () =>
    import(/* webpackChunkName: "AddTextMessage" */ "./views/AddTextMessage")
);
const AddDetails = lazy(
  () => import(/* webpackChunkName: "AddDetails" */ "./views/AddDetails")
);

const EnableCustomEngage = lazy(
  () =>
    import(
      /* webpackChunkName: "EnableCustomEngage" */ "./views/EnableCustomEngage"
    )
);

const MetaLanding = lazy(
  () => import(/* webpackChunkName: "MetaLanding" */ "./views/MetaLanding")
);

const ProductGrowth = lazy(
  () => import(/* webpackChunkName: "ProductGrowth" */ "./views/ProductGrowth")
);

const HowGrowEarning = lazy(
  () =>
    import(
      /* webpackChunkName: "HowGrowEarning" */ "./views/GrowthPostDetails/HowGrowEarning.jsx"
    )
);

const FestiveDeals = lazy(
  () =>
    import(
      /* webpackChunkName: "FestiveDeals" */ "./views/FestiveDeals/FestiveDeals.jsx"
    )
);

const FestiveDealsProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "FestiveDealsProducts" */ "./views/FestiveDeals/FestiveDealsProducts.jsx"
    )
);

const TopOffers = lazy(
  () =>
    import(
      /* webpackChunkName: "TopOffers" */ "./views/FestiveDeals/TopOffers.jsx"
    )
);

const ShopByCategory = lazy(
  () =>
    import(
      /* webpackChunkName: "ShopByCategory" */ "./views/FestiveDeals/ShopByCategory.jsx"
    )
);

const TopEcommerce = lazy(
  () => import(/* webpackChunkName: "TopEcommerce" */ "./views/TopEcommerce")
);

const BrandRewardDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandRewardDetail" */ "./views/BrandRewardDetail"
    )
);

const BrandRewardProductsList = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandRewardProductsList" */ "./views/BrandRewardProductsList"
    )
);

const BrandRewardReelViewer = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandRewardReelViewer" */ "./views/BrandRewardDetail/BrandRewardReelViewer"
    )
);

const ComingSoonBrandDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "ComingSoonBrandDetail" */ "./views/ComingSoonBrandDetail/index"
    )
);

const BrandDetail = lazy(
  () =>
    import(/* webpackChunkName: "BrandDetail" */ "./views/BrandDetail/index")
);

const OnboardedBrandDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardedBrandDetail" */ "./views/OnboardedBrandDetail"
    )
);

const BrandExperimentSaleDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandExperimentSaleDetail" */ "./views/BrandExperimentSaleDetail/index"
    )
);

const BrandExperimentSaleProductsList = lazy(
  () =>
    import(
      /* webpackChunkName: "BrandExperimentSaleProductsList" */ "./views/BrandExperimentSaleProductsList/index"
    )
);

const FestiveBannerPage = lazy(
  () =>
    import(
      /* webpackChunkName: "FestiveBannerPage" */ "./views/FestiveBannerPage"
    )
);

const ContentInspiration = lazy(
  () =>
    import(
      /* webpackChunkName: "ContentInspiration" */ "./views/ContentInspiration"
    )
);

const TelegramLogin = lazy(
  () => import(/* webpackChunkName: "TelegramLogin" */ "./views/TelegramLogin")
);

const CollageSelectProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "CollageSelectProducts" */ "./views/CollageCreation/SelectProducts"
    )
);

const CollageSelectImages = lazy(
  () =>
    import(
      /* webpackChunkName: "CollageSelectImages" */ "./views/CollageCreation/SelectImages"
    )
);

const CollageCreation = lazy(
  () =>
    import(
      /* webpackChunkName: "CollageCreation" */ "./views/CollageCreation/CollageCreation"
    )
);

const SuggestedActions = lazy(
  () =>
    import(
      /* webpackChunkName: "SuggestedActions" */ "./views/SuggestedActions"
    )
);

const SopChecklist = lazy(
  () => import(/* webpackChunkName: "SopChecklist" */ "./views/SopChecklist")
);

const CollabComingSoonPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CollabComingSoonPage" */ "./views/CollabComingSoon/CollabComingSoonPage"
    )
);

const HamburgerMenu = lazy(
  () => import(/* webpackChunkName: "HamburgerMenu" */ "./views/HamburgerMenu")
);

const PaidCollaboration = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidCollaboration" */ "./views/PaidCollab/PaidCollaboration"
    )
);

const ProductPreviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ProductPreviewPage" */ "./views/PaidCollab/ProductPreviewPage"
    )
);

const PaidCollabDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidCollabDetails" */ "./views/PaidCollabDetails/PaidCollabDetails"
    )
);
const PaidCollabChat = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidCollabChat" */ "./views/PaidCollabChat/PaidCollabChat"
    )
);

const CreatorAgentChat = lazy(
  () =>
    import(
      /* webpackChunkName: "CreatorAgentChat" */ "./views/CreatorAgentChat/CreatorAgentChat"
    )
);

const PaidCollabProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidCollabProducts" */ "./views/PaidCollabProducts"
    )
);
const PaidCollabCheckout = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidCollabCheckout" */ "./views/PaidCollabCheckout"
    )
);
const CheckoutSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: "CheckoutSuccess" */ "./views/PaidCollabCheckout/CheckoutSuccess"
    )
);

const CollabHistory = lazy(
  () =>
    import(
      /* webpackChunkName: "CollabHistory" */ "./views/PaidCollabDetails/CollabHistory"
    )
);

const BeautyPersonalCare = lazy(
  () =>
    import(
      /* webpackChunkName: "BeautyPersonalCare" */ "./views/BeautyPersonalCare"
    )
);

const BeautyDealsProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "BeautyDealsProducts" */ "./views/BeautyPersonalCare/BeautyDealProducts"
    )
);

const BeautyDeals = lazy(
  () =>
    import(
      /* webpackChunkName: "BeautyDeals" */ "./views/BeautyPersonalCare/BeautyDeals"
    )
);

const AutoContent = lazy(
  () => import(/* webpackChunkName: "Template1" */ "./views/AutoContent")
);

const Template1 = lazy(
  () =>
    import(
      /* webpackChunkName: "Template1" */ "./views/AutoContent/components/Template1"
    )
);

const Template2 = lazy(
  () =>
    import(
      /* webpackChunkName: "Template2" */ "./views/AutoContent/components/Template2"
    )
);

const WishlinkShopEducation = lazy(
  () =>
    import(
      /* webpackChunkName: "WishlinkShopEducation" */ "./views/WishlinkShopEducation"
    )
);

const AdjustmentEduPage = lazy(
  () =>
    import(
      /* webpackChunkName: "AdjustmentEduPage" */ "./views/AdjustmentEduPage"
    )
);

const FlaggedContentEdu = lazy(
  () =>
    import(
      /* webpackChunkName: "FlaggedContentEdu" */ "./views/FlaggedContentEduPage"
    )
);

const CollageCopy = lazy(
  () =>
    import(
      /* webpackChunkName: "CollageCreation/CollageCopy" */ "./views/CollageCreation"
    )
);
const WishlinkFacebookEducation = lazy(
  () =>
    import(
      /* webpackChunkName: "WishlinkFacebookEducation" */ "./views/FacebookEducation"
    )
);

const ProductGrowthEducation = lazy(
  () =>
    import(
      /* webpackChunkName: "ProductGrowthEducation" */ "./views/ProductGrowth/productGrowthEducation.jsx"
    )
);

const CrossPostAuthStatus = lazy(
  () =>
    import(
      /* webpackChunkName: "CrossPostAuthSuccess" */ "./views/CrossPostAuthStatus"
    )
);

const SwitchAccount = lazy(
  () => import(/* webpackChunkName: "SwitchAccount" */ "./views/SwitchAccount")
);

const Whitelisting = lazy(
  () =>
    import(
      /* webpackChunkName: "Whitelisting" */ "./sourcing/views/Whitelisting"
    )
);

const WhitelistingRouter = lazy(
  () =>
    import(
      /* webpackChunkName: "WhitelistingRouter" */ "./sourcing/views/Whitelisting/whitelistingrouter"
    )
);

const WhitelistingFtux = lazy(
  () =>
    import(
      /* webpackChunkName: "WhitelistingFtux" */ "./sourcing/views/WhitelistingFtux"
    )
);

const WhitelistingEligibility = lazy(
  () =>
    import(
      /* webpackChunkName: "WhitelistingEligibility" */ "./sourcing/views/WhitelistingEligibility"
    )
);

const CrashCourse = lazy(
  () => import(/* webpackChunkName: "CrashCourse" */ "./views/CrashCourse")
);

const AmazonBrandAccess = lazy(() => import("views/AmazonBrandAccess"));

const MeeshoQRCode = lazy(
  () => import(/* webpackChunkName: "MeeshoQRCode" */ "./views/MeeshoQRCode")
);

const WhatsNew = lazy(
  () => import(/* webpackChunkName: "WhatsNew" */ "./views/WhatsNew")
);

const WhatsNewDetails = lazy(
  () =>
    import(/* webpackChunkName: "WhatsNewDetails" */ "./views/WhatsNewDetails")
);

const CreatorCarnival = lazy(
  () =>
    import(/* webpackChunkName: "CreatorCarnival" */ "./views/CreatorCarnival")
);

const GST = lazy(() => import(/* webpackChunkName: "GST" */ "./views/GST"));

const McpConsent = lazy(
  () => import(/* webpackChunkName: "McpConsent" */ "./views/McpConsent")
);

const SelectByWishlink = lazy(
  () =>
    import(
      /* webpackChunkName: "SelectByWishlink" */ "./views/SelectByWishlink"
    )
);

const RewardProducts = lazy(
  () =>
    import(/* webpackChunkName: "RewardProducts" */ "./views/RewardProducts")
);

const Folders = lazy(
  () => import(/* webpackChunkName: "Folders" */ "./views/Folders")
);

const FolderDetail = lazy(
  () => import(/* webpackChunkName: "FolderDetail" */ "./views/FolderDetail")
);

const COCLandingPage = lazy(
  () =>
    import(
      /* webpackChunkName: "COCLandingPage" */ "./components/COC2026/COCLandingPage"
    )
);

const IGPostSuggestion = lazy(
  () =>
    import(
      /* webpackChunkName: "IGPostSuggestion" */ "./views/IGPostSuggestion"
    )
);

const appRoutes: AppRoute[] = [
  {
    path: PAGE_URLS.DEFAULT,
    access: Rule.blockIfHasAnyRole([
      UserRoleList.CREATOR,
      UserRoleList.CREATOR_ADMIN,
      UserRoleList.FIREBASE_AUTH,
    ]),
    component: FirebaseLogin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CREATOR_GST_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: GST,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CREATOR_CARNIVAL_PAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CreatorCarnival,
    showFooter: false,
  },
  {
    path: PAGE_URLS.MCP_CONSENT,
    access: Rule.public(),
    component: McpConsent,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SWITCH_ACCOUNT,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: SwitchAccount,
    showFooter: false,
  },
  {
    path: PAGE_URLS.META_LANDING,
    access: Rule.public(),
    component: MetaLanding,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENABLE_CUSTOM_ENGAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: EnableCustomEngage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FIRST_LINK_SELECT_BRANDS,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: FirstLinkSelectBrands,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FIREBASELOGIN,
    access: Rule.blockIfHasAnyRole([
      UserRoleList.CREATOR,
      UserRoleList.CREATOR_ADMIN,
      UserRoleList.FIREBASE_AUTH,
    ]),
    component: FirebaseLogin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.MEESHO_QR_CODE,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.MEESHO_QR_CODE__QR_ENABLED),
    ]),
    component: MeeshoQRCode,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REFERRALINPUT,
    access: Rule.hasRole(UserRoleList.FIREBASE_AUTH),
    component: ReferralInput,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SHOP,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CreatorShop,
    showFooter: true,
  },
  {
    path: PAGE_URLS.THRIFT_ADMIN,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ThriftAdmin,
    permanentlyMovedTo: PAGE_URLS.THRIFT_ADMIN_CONFIG,
    showFooter: false,
  },
  {
    path: "/thrift/:tab",
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ThriftAdmin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STORY_FRAMES,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: CreatorContent,
    showFooter: true,
  },
  {
    path: PAGE_URLS.NEWPOST,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: NewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.EDITPOST,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: NewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADDPRODUCTS,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: (userData: UserDataType) => {
      const isEngageV2Enabled =
        userData?.authorizations[UserAuthorizationList.ENGAGE_V2__ENABLED]
          ?.achieved;
      if (isEngageV2Enabled) return AddDetails;
      const isAutoScrapingEnabled =
        userData?.authorizations[UserAuthorizationList.AUTO_SCRAPING__ENABLED]
          ?.achieved;
      const isCustomEngageEnabled =
        userData?.authorizations[UserAuthorizationList.CUSTOM_ENGAGE__ENABLED]
          ?.achieved;
      const isBulkLinksEnabled =
        userData?.authorizations[UserAuthorizationList.BULK_LINKS__ENABLED]
          ?.achieved;
      return isAutoScrapingEnabled &&
        !isCustomEngageEnabled &&
        !isBulkLinksEnabled
        ? AddProductsAutoScrape
        : AddProducts;
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.CHOOSE_REPLY_TYPE,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: ChooseReplyType,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADD_CUSTOM_LINKS,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: AddCustomLinks,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADD_TEXT_MESSAGE,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: AddTextMessage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWLINKS,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: PreviewLinks,
    showFooter: false,
  },
  {
    path: PAGE_URLS.NEWCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: NewCollection,
    showFooter: false,
  },
  {
    path: PAGE_URLS.EDITCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: NewCollection,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADDPRODUCTSCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: AddProductsCollection,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWLINKSCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: PreviewLinks,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWPOST,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: PreviewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: PreviewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOCIALMEDIALOGIN,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
      Rule.blockIfHasAnyPermission([
        UserAuthorizationList.CREATOR_INSTAGRAM_LOGIN_COMPLETE,
        UserAuthorizationList.CREATOR_YOUTUBE_LOGIN_COMPLETE,
        UserAuthorizationList.CREATOR_TELEGRAM_LOGIN_COMPLETE,
        UserAuthorizationList.CREATOR_FACEBOOK_LOGIN_COMPLETE,
        // Also block when overall social login is active (OR of individual flags)
        UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE,
      ]),
    ]),
    component: SocialMediaLogin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.INSTALOGINSUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    component: InstaLoginSuccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FACEBOOKLOGINSUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    component: FacebookLoginSuccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FACEBOOKPAGESELECTION,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    component: FacebookPageSelection,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CROSSPOST,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
      // Rule.hasPermission(UserAuthorizationList.CROSS_POSTING__POSTING_ENABLED),
    ]),
    component: CrossPosting,
    showFooter: true,
  },
  {
    path: PAGE_URLS.SNAPCHAT_CROSSPOST,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: SnapchatCrossPosting,
    showFooter: true,
  },
  {
    path: PAGE_URLS.CROSSPOSTING_FTUX,
    access: Rule.all([Rule.hasRole(UserRoleList.CREATOR)]),
    component: CrossPostingFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CROSSPOSTING_EDUCATION,
    access: Rule.all([Rule.hasRole(UserRoleList.CREATOR)]),
    component: CrossPostingEducation,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CROSSPOSTING,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: CrossPostingV2,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PINTERESTLOGINSUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    showFooter: false,
    component: PinterestLoginSuccess,
  },
  {
    path: PAGE_URLS.SNAPCHATLOGINSUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    showFooter: false,
    component: SnapchatLoginSuccess,
  },
  {
    path: PAGE_URLS.YTLOGINSUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    component: YoutubeLoginSuccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.AFFILIATEPRODUCTS,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: AffiliateProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRANDS,
    access: Rule.public(),
    component: (userData: UserDataType) => {
      const isBrandsHubV2 =
        userData?.authorizations[UserAuthorizationList.BRANDS_HUB_V2__ENABLED]
          ?.achieved;
      return isBrandsHubV2 ? BrandsV2 : Brands;
    },
    showFooter: true,
  },
  {
    path: PAGE_URLS.BRANDS_HUB_OPPORTUNITIES,
    access: Rule.public(),
    component: BrandsHubOpportunities,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRANDS_HUB_EXCITING_SALES,
    access: Rule.public(),
    component: BrandsHubExcitingSales,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRANDS_HUB_FRESH_BRANDS,
    access: Rule.public(),
    component: BrandsHubFreshBrands,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRANDS_HUB_CONTENT_INSPIRATION,
    access: Rule.public(),
    component: BrandsHubContentInspiration,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRANDS_HUB_CONTENT_INSPIRATION_REEL,
    access: Rule.public(),
    component: BrandsHubContentInspirationReelEntry,
    showFooter: false,
  },
  {
    path: PAGE_URLS.DISCOVER_SEARCH_RESULTS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRANDS_HUB_V2__ENABLED),
    ]),
    component: DiscoverSearchResults,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CLOTHING,
    access: Rule.public(),
    component: Clothing,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PROFILE,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: Profile,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BANKDETAILS,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: BankDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.POSTANALYTICS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
    ]),
    component: PostAnalytics,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLECTIONANALYTICS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CollectionAnalytics,
    showFooter: false,
  },
  {
    path: PAGE_URLS.HOME,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        // do not change the order of these rules
        Rule.hasPermission(UserAuthorizationList.CREATOR_KYC_COMPLETE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE
        ),
      ]),
    ]),
    component: Home,
    showFooter: true,
  },
  {
    path: PAGE_URLS.ENGAGE,
    access: Rule.any([
      Rule.all([
        Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
        Rule.hasPermission(UserAuthorizationList.ENGAGE_ACTIVE),
      ]),
      Rule.hasRole(UserRoleList.CREATOR_ADMIN),
    ]),
    component: Engage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_INSTAGRAM,
    access: Rule.any([
      Rule.all([
        Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
        Rule.hasPermission(UserAuthorizationList.ENGAGE_ACTIVE),
      ]),
      Rule.hasRole(UserRoleList.CREATOR_ADMIN),
    ]),
    component: EngageInstagram,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_COMMENTS_INBOX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.ENGAGE_COMMENT_REPLIER__ENABLED),
    ]),
    component: EngageCommentsInbox,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_FACEBOOK,
    access: Rule.any([
      Rule.all([
        Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
        Rule.hasPermission(UserAuthorizationList.ENGAGE_FACEBOOK_ACTIVE),
      ]),
      Rule.hasRole(UserRoleList.CREATOR_ADMIN),
    ]),
    component: EngageFacebook,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADMIN,
    access: Rule.blockIfHasAnyRole([
      UserRoleList.CREATOR_ADMIN,
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR,
    ]),
    component: CreatorAdmin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CRM_EMBED,
    access: Rule.public(),
    component: CrmEmbed,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: Why,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_FTUX,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: EngageFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENABLEENGAGE,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: EngageRealisationFTUX,
    customFallback: CustomFallbacks.engageFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FACEBOOK_FTUX,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FacebookFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAB_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.blockIfHasPermission(
          UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE
        ),
        Rule.blockIfHasPermission(UserAuthorizationList.FTUX_BRAND_COLLAB),
      ]),
    ]),
    component: CollabFTUX,
    customFallback: CustomFallbacks.collabFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAB_CHAT_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.all([
        Rule.hasPermission(
          UserAuthorizationList.BRAND_COLLAB__COLLAB_CHAT_LIVE
        ),
      ]),
    ]),
    component: CollabChatFTUX,
    customFallback: CustomFallbacks.collabChatFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARDS_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.blockIfHasPermission(UserAuthorizationList.REWARDS__REWARDS_LIVE),
        Rule.blockIfHasPermission(UserAuthorizationList.FTUX_REWARDS),
      ]),
    ]),
    component: RewardsFTUX,
    customFallback: CustomFallbacks.rewardsFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARDS_REALISATION_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.blockIfHasPermission(UserAuthorizationList.FTUX_REWARDS),
    ]),
    customFallback: CustomFallbacks.rewardsFTUXAware,
    component: RewardsRealisationFTUX,
    showFooter: false,
  },

  {
    path: PAGE_URLS.COLLAB_REALISATION_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.blockIfHasPermission(UserAuthorizationList.FTUX_BRAND_COLLAB),
    ]),
    component: CollabRealisationFTUX,
    customFallback: CustomFallbacks.collabFTUXAware,
    showFooter: false,
  },

  {
    path: PAGE_URLS.GROWTH_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.blockIfHasPermission(
          UserAuthorizationList.GROWTH_V2__PRODUCT_GROWTH
        ),
        Rule.blockIfHasPermission(UserAuthorizationList.FTUX_GROWTH_V2),
      ]),
    ]),
    component: GrowthFTUX,
    customFallback: CustomFallbacks.growthFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.GROWTH_REALISATION_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.blockIfHasPermission(UserAuthorizationList.FTUX_GROWTH_V2),
    ]),
    customFallback: CustomFallbacks.growthFTUXAware,
    component: GrowthRealisationFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FACEBOOK_FTUX_V2,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FacebookFTUXV2,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SELECT_BY_WISHLINK_FTUX_V3,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: SelectByWishlinkFTUXV3,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SELECT_BY_WISHLINK_REWARDS_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: SelectByWishlinkRewardsFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SELECT_BY_WISHLINK_WRAP_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: SelectByWishlinkWrapFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STREAKS_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: StreaksFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SELECT_BY_WISHLINK,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(
        UserAuthorizationList.SELECT_BY_WISHLINK__SELECT_BY_WISHLINK_LIVE
      ),
    ]),
    component: SelectByWishlink,
    showFooter: false,
  },
  {
    path: PAGE_URLS.AUTHSTATUS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.FIREBASE_AUTH]),
    component: AuthStatus,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FAQ,
    access: Rule.hasAnyRole([
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR,
      UserRoleList.CREATOR_ADMIN,
    ]),
    component: Faq,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FAQ_ITEM,
    access: Rule.hasAnyRole([
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR,
      UserRoleList.CREATOR_ADMIN,
    ]),
    component: FaqItem,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FAQ_QUESTION,
    access: Rule.hasAnyRole([
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR,
      UserRoleList.CREATOR_ADMIN,
    ]),
    component: FaqQuestion,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOCIAL_LOGIN_SUCCESS,
    access: Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
    component: SocialLoginSuccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.LOGIN_SUCCESS_INSTAGRAM,
    access: Rule.public(),
    component: LoginSuccess,
    props: {
      platform: "instagram",
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.LOGIN_SUCCESS_FACEBOOK,
    access: Rule.public(),
    component: LoginSuccess,
    props: {
      platform: "facebook",
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.LOGIN_SUCCESS_YOUTUBE,
    access: Rule.public(),
    component: LoginSuccess,
    props: {
      platform: "youtube",
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.ERROR_PAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.FIREBASE_AUTH]),
    component: ErrorPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PRODUCTANALYTICS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ProductAnalytics,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PLAYBOOK,
    access: Rule.public(),
    component: Playbook,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PLAYBOOK_CONTENT,
    access: Rule.public(),
    component: PlaybookContent,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PLAYBOOK_MONETIZE,
    access: Rule.public(),
    component: PlaybookMonetize,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADDRESS,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: Address,
    showFooter: false,
  },

  // Sourcing Maintenance
  {
    path: PAGE_URLS.SOURCING_MAINTENANCE,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: SourcingMaintenance,
    showFooter: false,
  },

  // Sourcing URLS
  {
    path: PAGE_URLS.SOURCING,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
      Rule.hasPermission(UserAuthorizationList.FTUX_SOURCING),
    ]),
    component: SourcingHome,
    customFallback: CustomFallbacks.sourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_COLLECTION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingCollection,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_PRODUCT_URL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingProduct,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_CART,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingCart,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_WISHLIST,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingWishlist,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_MY_ORDERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingMyOrders,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_MANUAL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: ManualSourcing,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_MANUAL_ADD,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: ManualSourcing,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_MANUAL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: ManualSourcing,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_MANUAL_ADD,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: ManualSourcing,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_ACCESS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: SourcingAccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_LOCKED,
    access: Rule.public(),
    component: SourcingLocked,
    showFooter: false,
    permanentlyMovedTo: PAGE_URLS.HOME,
  },
  {
    path: PAGE_URLS.SOURCING_COINS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingCredits,
    showFooter: false,
  },
  {
    path: PAGE_URLS.MINI_SOURCING_ACTIVE_ORDERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: MiniSourcingActiveOrders,
    showFooter: false,
  },
  {
    path: PAGE_URLS.MINI_SOURCING_CART,
    access: Rule.public(),
    component: MiniSourcingCart,
    showFooter: false,
    permanentlyMovedTo: PAGE_URLS.HOME,
  },
  {
    path: PAGE_URLS.SOURCING_NEW_PDP,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingProduct,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_NEW_BARTER_PDP,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),
        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: SourcingProduct,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_MINI,
    access: Rule.public(),
    component: SourcingMini,
    showFooter: false,
    permanentlyMovedTo: PAGE_URLS.HOME,
  },
  {
    path: PAGE_URLS.SOURCING_CREDIT_HISTORY,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
    ]),
    component: SourcingCreditHistory,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_ORDER_CONFIRMATION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOURCING_ENABLED),
    ]),
    component: SourcingOrderConfirmation,
    showFooter: false,
  },
  // Sourcing END

  // Product Reviews
  {
    path: PAGE_URLS.SOURCING_PRODUCT_REVIEWS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
    ]),
    component: SourcingProductReviews,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOURCING_PRODUCT_REVIEW_FORM,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
    ]),
    component: SourcingProductReviewForm,
    showFooter: false,
  },
  // Product Reviews End

  // Brand And Sourcing Unified Endpoint(s) Starts
  {
    path: PAGE_URLS.BRAND_AND_SOURCING_UNIFIED_MY_ORDERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: BrandAndSourcingUnifiedMyOrders,
    showFooter: false,
  },
  // Brand And Sourcing Unified Endpoint(s) Ends

  // Brand Sourcing Starts
  {
    path: PAGE_URLS.BRAND_SOURCING_HOME,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingHome,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_CREDIT_HISTORY,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingCreditHistory,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_FTUX,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    ]),
    component: BrandSourcingFTUX,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_GLOBAL_WISHLIST,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingUnifiedWishlist,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_BRAND_WISHLIST,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingWishlist,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_ORDER_CONFIRMATION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingOrderConfirmation,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_CART,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingCartWrapper,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_COLLECTION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingCollection,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_MY_ORDERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingMyOrders,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_PRODUCT_URL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingProduct,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_SOURCING_NEW_PDP,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_BRAND_SOURCING_ENABLED),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.RTC_SELECTIVE__LIVE),

        Rule.blockIfHasPermission(
          UserAuthorizationList.RTC_FINAL_APPROVAL__BLOCKED
        ),
      ]),
    ]),
    component: BrandSourcingProduct,
    customFallback: CustomFallbacks.brandSourcingEntryPoint,
    showFooter: false,
  },
  // Brand Sourcing Ends

  {
    path: PAGE_URLS.NOTIFICATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: Notification,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TNC,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: Tnc,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REFERRAL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.blockIfHasAnyPermission([
        UserAuthorizationList.CREATOR_WAITLISTED,
        UserAuthorizationList.REFERRAL_PROGRAM__REFERRAL_DISABLED,
      ]),
    ]),
    component: Referral,
    showFooter: false,
  },
  {
    path: PAGE_URLS.RECOMMENDED_COLLECTIONS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.blockIfHasPermission(UserAuthorizationList.CREATOR_WAITLISTED),
    ]),
    component: RecommendedCollections,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_BESTSELLERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.SOCIAL_LOGIN_MILESTONE_COMPLETE),
      Rule.blockIfHasPermission(UserAuthorizationList.CREATOR_WAITLISTED),
    ]),
    component: RecommendedCollections,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWRECOMMENDEDCOLLECTION,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.blockIfHasPermission(UserAuthorizationList.CREATOR_WAITLISTED),
    ]),
    component: PreviewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PREVIEWWISHLINKBESTSELLER,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.blockIfHasPermission(UserAuthorizationList.CREATOR_WAITLISTED),
    ]),
    component: PreviewPost,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WELCOME,
    access: Rule.blockIfHasAnyRole([
      UserRoleList.CREATOR,
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR_ADMIN,
    ]),
    component: Welcome,
    showFooter: false,
  },
  {
    path: PAGE_URLS.OTP,
    access: Rule.blockIfHasAnyRole([
      UserRoleList.CREATOR,
      UserRoleList.FIREBASE_AUTH,
      UserRoleList.CREATOR_ADMIN,
    ]),
    component: Otp,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FAVOURITE_BRANDS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FavouriteBrands,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CREATOR_OAUTH,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: WishlinkCreatorOauth,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAYOUT_PRELAUNCH,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PayoutExplainerVideo,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ANALYTICS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: AnalyticsV2,
    showFooter: true,
  },
  {
    path: PAGE_URLS.WISHLINK_SHOPPING_PAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WishlinkShoppingPage,
    showFooter: false,
  },

  {
    path: PAGE_URLS.PENDING_COMMISSION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PendingCommission,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CONFIRMED_COMMISSION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ConfirmedCommission,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAYOUT_STATUS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PayoutStatusPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAYOUT_ORDER_LEDGER,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PayoutOrderLedger,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAST_PAYOUTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PastPayouts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAST_PAYOUTS_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PastPayoutDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.LEVIED,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: Levied,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ANALYTICS_TNC,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: AnalyticsTNC,
    showFooter: false,
  },
  {
    path: PAGE_URLS.POST_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PostDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STORY_FRAME_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: PostFrameDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.USER_BLOCKED,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: UserBlocked,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_COMMENT,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: (userData: UserDataType) => {
      const isFeatureEnabled =
        userData.authorizations[
          UserAuthorizationList.FACEBOOK_SERVICE__CHANNEL_ENABLED
        ]?.achieved;
      return isFeatureEnabled ? EngageCommentV2 : EngageComment;
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_SHARE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: (userData: UserDataType) => {
      const isFeatureEnabled =
        userData.authorizations[
          UserAuthorizationList.FACEBOOK_SERVICE__CHANNEL_ENABLED
        ]?.achieved;
      return isFeatureEnabled ? EngageShareV2 : EngageShare;
    },
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_REWARDS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.REWARDS__REWARDS_LIVE),
      Rule.hasPermission(UserAuthorizationList.FTUX_REWARDS),
    ]),
    component: WishlinkRewards,
    customFallback: CustomFallbacks.rewardsFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STREAK_LEARN_MORE,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.STREAKS_V2__ENABLED),
    ]),
    component: StreakLearnMoreRedirect,
    customFallback: CustomFallbacks.streaksFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STREAK_TRACK_PROGRESS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.STREAKS_V2__ENABLED),
    ]),
    component: StreakTrackProgress,
    customFallback: CustomFallbacks.streaksFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_STREAKS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.STREAKS_V2__ENABLED),
    ]),
    component: WishlinkStreaks,
    customFallback: CustomFallbacks.streaksFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARD_DETAILS_POSTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: RewardPostListDrilldown,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARD_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: RewardDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARD_HISTORY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: RewardHistory,
    showFooter: false,
  },
  {
    path: PAGE_URLS.DISCOVER_CONTENT,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),

    component: DiscoverContent,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARD_LEADERBOARD,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: RewardFullLeaderboard,
    showFooter: false,
  },
  {
    path: PAGE_URLS.MONTHLY_ORDER_STATUS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: MonthlyOrderStatus,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COPY_LINKS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CopyLinks,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGEDEBUGGER,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.ENGAGE_ACTIVE),
    ]),
    component: EngageDebugger,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_DIAGONISIS_REPORT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.ENGAGE_ACTIVE),
    ]),
    component: EngageDiagnosisReport,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CREATE_DIY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CreateDiy,
    showFooter: true,
  },
  {
    path: PAGE_URLS.KYC,
    access: Rule.all([
      Rule.hasRole(UserRoleList.CREATOR),
      Rule.blockIfHasPermission(UserAuthorizationList.CREATOR_KYC_COMPLETE),
    ]),
    component: Kyc,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PRODUCT_GROWTH,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.GROWTH_V2__PRODUCT_GROWTH),
      Rule.hasPermission(UserAuthorizationList.FTUX_GROWTH_V2),
    ]),
    component: ProductGrowth,
    customFallback: CustomFallbacks.growthFTUXAware,
    showFooter: false,
  },
  {
    path: PAGE_URLS.HOW_GROW_EARNING,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.GROWTH_V2__PRODUCT_GROWTH),
    ]),
    component: HowGrowEarning,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FESTIVE_DEALS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FestiveDeals,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FESTIVE_DEAL_PRODUCTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FestiveDealsProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TOP_OFFERS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: TopOffers,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SHOP_BY_CATEGORY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ShopByCategory,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TOP_ECOMMERCE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: TopEcommerce,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_REWARD_DETAIL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_NEWME__ENABLED),
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_OFFDUTY__ENABLED),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_SWISSBEAUTY__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_FABLESTREET__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_LAZOSTORE__ENABLED
        ),
      ]),
    ]),
    component: BrandRewardDetail,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_REWARD_PRODUCTS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_NEWME__ENABLED),
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_OFFDUTY__ENABLED),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_SWISSBEAUTY__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_FABLESTREET__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_LAZOSTORE__ENABLED
        ),
      ]),
    ]),
    component: BrandRewardProductsList,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_REWARD_REELS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_NEWME__ENABLED),
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_OFFDUTY__ENABLED),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_SWISSBEAUTY__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_FABLESTREET__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_LAZOSTORE__ENABLED
        ),
      ]),
    ]),
    component: BrandRewardReelViewer,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COMING_SOON_BRAND_DETAIL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_TIGC__ENABLED),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_PANTALOONS__ENABLED
        ),
      ]),
    ]),
    component: ComingSoonBrandDetail as any,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COMING_SOON_BRAND_REELS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_TIGC__ENABLED),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_PANTALOONS__ENABLED
        ),
      ]),
    ]),
    component: BrandRewardReelViewer,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ONBOARDED_BRAND_DETAIL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_BEWAKOOF__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_FIRSTCRY__ENABLED
        ),
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_URBANO__ENABLED),
      ]),
    ]),
    component: OnboardedBrandDetail as any,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ONBOARDED_BRAND_REELS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_BEWAKOOF__ENABLED
        ),
        Rule.hasPermission(
          UserAuthorizationList.BRAND_REWARD_FIRSTCRY__ENABLED
        ),
        Rule.hasPermission(UserAuthorizationList.BRAND_REWARD_URBANO__ENABLED),
      ]),
    ]),
    component: BrandRewardReelViewer,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_EXPERIMENT_SALE_REELS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BrandRewardReelViewer,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_DETAIL,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BrandDetail,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COMING_SOON_BRAND_EXPERIMENT_DETAIL,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ComingSoonBrandDetail,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_EXPERIMENT_SALE_PRODUCTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BrandExperimentSaleProductsList as any,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_EXPERIMENT_SALE_DETAIL,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BrandExperimentSaleDetail as any,
    showFooter: false,
  },
  {
    path: PAGE_URLS.NEW_LAUNCHES,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: TopEcommerce,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CONTENT_INSPIRATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ContentInspiration,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FESTIVE_BANNER_PAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FestiveBannerPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FESTIVE_RECORD_PAGE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FestiveRecordPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TELEGRAM_LOGIN,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.FIREBASE_AUTH, UserRoleList.CREATOR]),
      Rule.blockIfHasAnyPermission([
        UserAuthorizationList.CREATOR_TELEGRAM_LOGIN_COMPLETE,
        UserAuthorizationList.CREATOR_SOCIAL_ACCOUNT_TYPE,
      ]),
    ]),
    component: TelegramLogin,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAGE_SELECT_PRODUCTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CollageSelectProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAGE_SELECT_IMAGES,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CollageSelectImages,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAGE_CREATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CollageCreation,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SUGGESTED_ACTIONS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: SuggestedActions,
    showFooter: false,
  },
  {
    path: PAGE_URLS.SOP_CHECKLIST,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: SopChecklist,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
      Rule.hasPermission(UserAuthorizationList.FTUX_BRAND_COLLAB),
      Rule.hasPermission(UserAuthorizationList.FTUX_COLLAB_CHAT),
    ]),
    component: PaidCollaboration,
    customFallback: CustomFallbacks.collabChatConditional,
    showFooter: false,
  },

  {
    path: PAGE_URLS.PRODUCT_PREVIEW,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ProductPreviewPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAB_COMMING_SOON,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(
        UserAuthorizationList.BRAND_COLLAB__COLLAB_COMING_SOON
      ),
    ]),
    component: CollabComingSoonPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION_DETAILS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: PaidCollabDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION_CHAT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: PaidCollabChat,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION_CHAT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: PaidCollabChat,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHII_CHAT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR]),
      Rule.hasPermission(UserAuthorizationList.WISHII_CREATOR_AGENT__ENABLED),
    ]),
    component: CreatorAgentChat,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHII,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR]),
      Rule.hasPermission(UserAuthorizationList.WISHII_CREATOR_AGENT__ENABLED),
    ]),
    component: CreatorAgentChat,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAB_HISTORY,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: CollabHistory,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION_PRODUCTS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: PaidCollabProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PAID_COLLABORATION_CHECKOUT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: PaidCollabCheckout,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CHECKOUT_SUCCESS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.BRAND_COLLAB__COLLAB_LIVE),
    ]),
    component: CheckoutSuccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.HAMBURGER_MENU,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: HamburgerMenu,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_WRAPPED_2025,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR_ADMIN, UserRoleList.CREATOR]),
      Rule.hasPermission(
        UserAuthorizationList.WISHLINK_WRAPPED__WISHLINK_WRAPPED_2025
      ),
    ]),
    component: WishlinkWrapped25,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BEAUTY_AND_PERSONAL_CARE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BeautyPersonalCare,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BEAUTY_PRODUCTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BeautyDealsProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BEAUTY_DEALS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BeautyDeals,
    showFooter: false,
  },
  {
    path: PAGE_URLS.INDEX,
    access: Rule.public(),
    component: Home,
    showFooter: true,
    permanentlyMovedTo: PAGE_URLS.HOME,
  },
  {
    path: PAGE_URLS.AUTO_CONTENT,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(
        UserAuthorizationList.AUTO_CONTENT__AUTO_CONTENT_ENABLED
      ),
    ]),
    component: AutoContent,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TEMPLATE_1,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(
        UserAuthorizationList.AUTO_CONTENT__AUTO_CONTENT_ENABLED
      ),
    ]),
    component: Template1,
    showFooter: false,
  },
  {
    path: PAGE_URLS.TEMPLATE_2,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(
        UserAuthorizationList.AUTO_CONTENT__AUTO_CONTENT_ENABLED
      ),
    ]),
    component: Template2,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_SHOP_EDUCATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WishlinkShopEducation,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ADJUSTMENT_EDUCATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: AdjustmentEduPage,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FLAGGED_CONTENT_EDUCATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: FlaggedContentEdu,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WISHLINK_FACEBOOK_EDUCATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WishlinkFacebookEducation,
    showFooter: false,
  },
  {
    path: PAGE_URLS.COLLAGE_COPY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: CollageCopy,
    showFooter: false,
  },
  {
    path: PAGE_URLS.PRODUCT_GROWTH_EDUCATION,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: ProductGrowthEducation,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CROSSPOSTAUTHSUCCESS,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: CrossPostAuthStatus,
    showFooter: false,
  },
  {
    path: PAGE_URLS.APPLOGIN,
    access: Rule.public(),
    component: AppLoginTrigger,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ORDER_HISTORY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: OrderHistory,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHITELISTINGROUTER,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WhitelistingRouter,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHITELISTINGFTUX,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WhitelistingFtux,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHITELISTING,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: Whitelisting,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHITELISTING_ELIGIBILITY_PAGE_URL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.CREATOR_SOCIAL_LOGIN_ACTIVE),
    ]),
    component: WhitelistingEligibility,
    showFooter: false,
  },
  {
    path: PAGE_URLS.CRASH_COURSE,
    access: Rule.public(),
    component: CrashCourse,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BANKDETAILSVERIFICATION,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: BankDetailsVerification,
    showFooter: false,
  },
  {
    path: PAGE_URLS.RAZORPAYVERIFICATION,
    access: Rule.hasRole(UserRoleList.CREATOR),
    component: RazorpayVerificationFlow,
    showFooter: false,
  },
  {
    path: PAGE_URLS.AMAZON_BRAND_ACCESS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: AmazonBrandAccess,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHATS_NEW,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WhatsNew,
    showFooter: false,
  },
  {
    path: PAGE_URLS.WHATS_NEW_DETAILS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: WhatsNewDetails,
    showFooter: false,
  },
  {
    path: PAGE_URLS.REWARD_PRODUCTS,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: RewardProducts,
    showFooter: false,
  },
  {
    path: PAGE_URLS.FOLDERS,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.SHARE_TO_WISHLINK__ENABLED),
        Rule.hasPermission(UserAuthorizationList.IN_APP_BROWSER__ENABLED),
      ]),
    ]),
    component: Folders,
    showFooter: true,
  },
  {
    path: PAGE_URLS.FOLDER_DETAIL,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.any([
        Rule.hasPermission(UserAuthorizationList.SHARE_TO_WISHLINK__ENABLED),
        Rule.hasPermission(UserAuthorizationList.IN_APP_BROWSER__ENABLED),
      ]),
    ]),
    component: FolderDetail,
    showFooter: true,
  },
  {
    path: PAGE_URLS.COC_LANDING,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: COCLandingPage,
    showFooter: false,
  },
  {
    // CAT-407 — kept alive for the deep links web cannot grep: WebEngage
    // campaigns, push payloads and universal links into the WebView. Renders
    // the entry point, which lands the creator on Home with the journey open.
    path: PAGE_URLS.SETUP_JOURNEY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: SetupJourneyRouteEntry,
    showFooter: false,
  },
  {
    // CAT-510 — PTFW V3 intent capture. Mandatory for the TEST bucket, so the
    // screen itself owns the "already answered" redirect rather than a route
    // guard (the guard rules are sync and read only creator config).
    path: PAGE_URLS.INTENT_CAPTURE,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: IntentCapture,
    showFooter: false,
  },
  {
    path: PAGE_URLS.ENGAGE_SETUP_JOURNEY,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: EngageSetupJourney,
    showFooter: false,
  },
  {
    path: PAGE_URLS.BRAND_CAMPAIGN_UH_OH,
    access: Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
    component: BrandCampaignUhOh,
    showFooter: false,
  },
  {
    path: PAGE_URLS.STREAKS_HOW_IT_WORKS,
    access: Rule.public(),
    component: StreaksHowItWorks,
    showFooter: false,
  },
  {
    path: PAGE_URLS.IG_POST_SUGGESTION,
    access: Rule.all([
      Rule.hasAnyRole([UserRoleList.CREATOR, UserRoleList.CREATOR_ADMIN]),
      Rule.hasPermission(UserAuthorizationList.IG_POST_SUGGESTION__ENABLED),
    ]),
    component: IGPostSuggestion,
    showFooter: false,
  },
  {
    path: "/*",
    access: Rule.public(),
    component: ErrorPage,
    showFooter: false,
  },
];
export default appRoutes;
